import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "What do I need to rent a car?", a: "A valid driver's licence, a form of ID, and a credit/debit card for the security deposit. (Editable placeholder — confirm exact policy.)" },
  { q: "What driver's licence is required?", a: "A full valid licence held for at least 1-2 years. International licences may require an IDP. (Editable placeholder.)" },
  { q: "Is there a minimum driver age?", a: "Minimum driver age policies vary by vehicle category. Please confirm at the time of booking. (Editable placeholder.)" },
  { q: "Is a security deposit required?", a: "Yes, a refundable security deposit is held on your card at pickup. Amount depends on vehicle category. (Editable placeholder.)" },
  { q: "What happens if I return the vehicle late?", a: "Late returns are charged per hour up to a full day. Please contact us in advance to arrange extensions. (Editable placeholder.)" },
  { q: "Can I add another driver?", a: "Yes. Additional drivers can be added at pickup for a small fee. All additional drivers must present a valid licence. (Editable placeholder.)" },
  { q: "What happens if I need to cancel?", a: "Free cancellation up to 48 hours before pickup is available on most bookings. (Editable placeholder — confirm your policy.)" },
  { q: "What insurance is included?", a: "Basic third-party cover is included. Silver and Gold Zero Excess options reduce your liability. See Rates for details." },
  { q: "Where do I pick up the vehicle?", a: "Pickups from our office or airport delivery on request. Contact us for out-of-hours arrangements. (Editable placeholder.)" },
  { q: "Can I extend my rental?", a: "Yes, subject to availability. Contact us at least 24 hours before your return date to arrange an extension." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#D9A62E] font-mono-piki font-semibold">FAQ</div>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-white">Frequently Asked</h1>
      <p className="mt-3 text-[#A3A3A3]">Answers to common rental questions. Editable placeholder content — confirm policies with your real business.</p>

      <Accordion type="single" collapsible className="mt-10 space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="piki-card px-5 border-none" data-testid="faq-accordion-item">
            <AccordionTrigger className="text-left text-white font-semibold hover:text-[#D9A62E] hover:no-underline py-5" data-testid="faq-accordion-trigger">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#A3A3A3] text-sm leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
